export const Gateways = {
    CALL: 1,
    SMS: 2,
    SMARTPHONE: 3,
    EMAIL: 4,
    WHATSAPP: 5,
    PAGER: 6
};
